"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CrossMedium;

var _CrossMedium = require("@adobe/react-spectrum-ui/dist/CrossMedium.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CrossMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CrossMedium.CrossMedium, null));
}